// extracted by css-extract-rspack-plugin
export default {"header":"header-jJTIaM","title":"title-hnjsYA","subtitle":"subtitle-qxUa60"};